import { CSSProperties } from "react";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

const MENU_WIDTH = 260;

export const container: CSSProperties = {
  position: "absolute",
  zIndex: 2, // position above chrome-wrapper
  height: "100%",
  width: MENU_WIDTH,
  backgroundColor: greys.white,
  boxShadow: `10px 0 10px 0px rgba(0, 0, 0, .15)`,
  // transition stuff
  transition: "all 0.35s ease-in-out",
  overflow: "hidden",
};

export const content: CSSProperties = {
  position: "absolute",
  right: 0,
  width: MENU_WIDTH,
  height: "100%",
  display: "flex",
  flexDirection: "column",
};

export const hidden: CSSProperties = {
  visibility: "hidden",
  width: 0,
};
